import Modal from "react-bootstrap/Modal";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";

const LoadingPopup = (props) => {
  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
      className="LoginModal"
    >
      <Modal.Body
        style={{ direction: getDir(getCurrentLangFromRedux()) }}
        className="d-flex flex-column align-items-center"
      >
        <div className="loading-wrapper">
          <img
            // projects version
            src={`${"/assets/images/idsclogo.png"}`}
            width={400}
            className="py-2 px-4"
            alt="logo"
          />

          <h4
            className="text-center px-2 my-4"
            style={{
              lineHeight: "40px",
            }}
          >
            منظومة متابعة الاجراءات التنفيذية للبريكس
          </h4>
        </div>
        <section className="section section-2">
          <span className="loader loader-double"></span>
        </section>
      </Modal.Body>
    </Modal>
  );
};
export default LoadingPopup;
